module.exports = {"en-US":{"echo":{"show":{"shout":"What goes around...","placeholder":"...comes around!"}}}}